<app-loading *ngIf="isLoading._value"></app-loading>
<section>
  <div class="bg_image">
    <div>
      <div class="bg_subtitle">RÁPIDO, FÁCIL Y SEGURO</div>
      <h1 class="bg_title">PAGA TU DEUDA AL INSTANTE</h1>
      <form class="searchForm" [formGroup]="form" (ngSubmit)="onSubmit()">
        <input
          #searchInput
          [class.filled]="form.dirty"
          [placeholder]="placeholder"
          type="search"
          formControlName="search"
          maxlength="63"
          minlength="5">
        <span class="hint">Ingresa tu dominio, N° de Orden o correo electrónico</span>
        <button class="btn" mat-button [disabled]="(form.invalid || isLoading._value)" type="submit">
          Consultar Deuda
        </button>
      </form>
    </div>
  </div>
</section>
